import {
  CLICK_MODAL_OPEN,
  CLICK_MODAL_CLOSE,
} from "@/shared/components/photo_gallery/constants/action_types";

// 初期値
const initialState = {
  index: null,
};

// Action の種別によってステータスを更新
// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
  switch (action.type) {
    case CLICK_MODAL_OPEN: {
      window.St.modal = true;

      return {
        index: action.payload.index,
      };
    }
    case CLICK_MODAL_CLOSE: {
      window.St.modal = false;

      return {
        index: null,
      };
    }
    default: {
      return state;
    }
  }
};
